<template>
    <v-row dense>
        <template v-for="(item, index) in routesQuantity" :key="index">
            <v-col v-if="routesQuantity.length > 1" cols="1" class="px-0 d-flex justify-center align-center">
                <v-btn variant="text" @click="deleteRoute(index)">
                    <v-icon color="error">mdi-close</v-icon>
                </v-btn>
            </v-col>
            <v-col :cols="routesQuantity.length > 1 ? 11 : 12">
                <one-way
                    v-model="routeLocations[index]"
                    :form-index="index"
                    :init-search="initSearch"
                    @form-data="addRoute(index, $event)"
                />
                <v-divider v-if="index < routesQuantity.length - 1" class="mt-4 mb-2 d-md-none" />
            </v-col>
        </template>
        <v-col cols="12">
            <v-btn
                :size="$breakpoint.smAndDown ? 'x-small' : 'default'"
                variant="text"
                class="text-white h6"
                data-cy="add-route"
                @click="addNewRoute"
            >
                {{ $t('flights.add_route') }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script lang="ts">
    import {Component, Watch, Prop, Vue} from 'vue-facing-decorator'
    import OneWay from '@/components/flights/search/forms/OneWay.vue'

    @Component({
        components: {
            OneWay,
        },
    })
    export class MultiCity extends Vue {
        @Prop() initSearch

        routesQuantity = ['route-0']
        routes = []
        routeLocations = [{from: null, to: null}]

        @Watch('initSearch')
        onSearchInit() {
            this.routes = []
        }

        @Watch('routes', {deep: true})
        onRoutesChange() {
            if (this.routes.length === this.routesQuantity.length) {
                this.$emit('form-data', this.routes)
            }
        }

        created() {
            for (let i = 1; i < flightsRuntimeStore.routes.length; i++) {
                this.addNewRoute()
            }
        }

        addNewRoute() {
            this.routesQuantity.push(`route-${this.routesQuantity.length}`)
            this.routeLocations.push({from: null, to: null})
        }

        addRoute(index, route) {
            this.routes.push(route[0])
        }

        deleteRoute(index) {
            this.routesQuantity.splice(index, 1)
            this.routeLocations.splice(index, 1)
        }
    }

    export default MultiCity
</script>

<style scoped lang="scss">
    .v-divider {
        border-color: white;
    }
</style>
